import React from 'react'
import { Column } from '@ant-design/plots'

export default function Chart({ data }: { data: any }) {
  const config = {
    data,
    xField: 'date',
    yField: 'value',
    colorField: 'type',
    group: {
      padding: 0,
    },
    animation: false,
    title: 'Carusg pv & uv',
  }

  if (!data?.length) return null

  return <Column {...config} />
}
